import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const RedeemBonusDetails = lazyRouteComponent(
  () => import('../../pages/profile/redeem-bonus-details'),
)

export const redeemBonusDetailsRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'redeem-bonus-details',
  component: RedeemBonusDetails,
})
